'use client';
import React from 'react';
import { usePathname } from 'next/navigation';
import { AnimatePresence } from 'framer-motion';
import PageTransition from '@/components/PageTransition';

export default function FanLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <PageTransition routeKey={pathname}>
        {children}
      </PageTransition>
    </AnimatePresence>
  );
}
